// Falsy entries are dropped, so a `cond && 'class'` reads inline without a ternary
// spelling out the `: undefined` branch.
export function classNames (...classes: (string | false | null | undefined)[]) {
  return classes.filter(Boolean).join(' ')
}
